/*
 * 生成带阿里云参数的图片
 * @param url:图片链接
 * @param options
 * @returns imageUrl
 */
export function generateImageJpg(url, options) {
  if (!url || !options) {
    return url;
  }
  if (url.indexOf("img.souche.com") < 0 && url.indexOf(".aliyuncs.com") < 0) {
    return url;
  }
  if (url.trimEnd().match(/(svg|webp)$/) || url.indexOf("x-oss-process") >= 0 || url.split("?").length >= 2) {
    return url;
  }
  let resize = "";
  const imgType = "/format,jpg/interlace,1"; // 图片类型；interlace：渐进显示,从模糊逐渐变成清晰，仅jpg有效
  // const quality = `/quality,Q_100`; // 图片压缩质量
  const orient = "/auto-orient,1"; // 图片自动校正旋转方向
  // 图片裁剪
  if (options) {
    // eslint-disable-next-line radix
    resize = `/resize,m_fill,w_${Number.parseInt(options.width * 1)},h_${Number.parseInt(options.height * 1)},limit_0`;
  }
  // 改为相对协议
  return `${url.replace(/(http|https):/gi, "")}?x-oss-process=image${resize}${orient}${imgType}`;
}

export function generateImageWebp(url, options) {
  if (!url) {
    return url;
  }
  if (url.indexOf("img.souche.com") < 0 && url.indexOf(".aliyuncs.com") < 0) {
    return url;
  }
  if (url.trimEnd().match(/(svg|webp)$/) || url.indexOf("x-oss-process") >= 0 || url.split("?").length >= 2) {
    return url;
  }
  const imgType = "/format,webp";
  if (!options) {
    return `${url.replace(/(http|https):/gi, "")}?x-oss-process=image${imgType}`;
  }
  let resize = "";
  // const quality = `/quality,Q_80`; // 图片压缩质量
  const orient = "/auto-orient,1"; // 图片自动校正旋转方向
  // 图片裁剪
  if (options) {
    // eslint-disable-next-line radix
    resize = `/resize,m_fill,w_${Number.parseInt(options.width * 1)},h_${Number.parseInt(options.height * 1)},limit_0`;
  }
  // 改为相对协议
  return `${url.replace(/(http|https):/gi, "")}?x-oss-process=image${resize}${orient}${imgType}`;
}

export function generateVideoCover(video) {
  return `${video}?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast`;
}



// WEBPACK FOOTER //
// ./src/utils/image.js